import * as React from 'react';
import SpotlightImageComponent from './spotlight-image';

const ImageModule = (props: any) => {  
  return (    
    <SpotlightImageComponent id={props.id} image={props.image} device={props.device} key={props.id} />    
  );
};

export default ImageModule;
